import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDzen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Clip path group",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_4201_22306",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 13,
			height: 13,
			children: /* @__PURE__ */ _jsx("g", {
				id: "clip0_45_484",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M12.04 0H0V12.04H12.04V0Z",
					fill: ""
				})
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_4201_22306)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Subtract",
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M6.04256 12.0378H5.99456C3.60476 12.0378 2.20713 11.7972 1.23359 10.8429C0.231387 9.82072 0 8.43308 0 6.05259V5.98525C0 3.60476 0.231387 2.20713 1.23359 1.1949C2.21644 0.2407 3.60476 0 5.99528 0H6.04328C8.42379 0 9.82139 0.2407 10.8036 1.1949C11.8057 2.21716 12.0372 3.60476 12.0372 5.98525V6.05259C12.0372 8.4338 11.8057 9.83075 10.8036 10.8429C9.82067 11.7972 8.43311 12.0378 6.04256 12.0378ZM10.5216 5.84225C10.5675 5.8444 10.6048 5.88236 10.6048 5.9282H10.604V6.12016C10.604 6.16672 10.5668 6.20468 10.5209 6.20611C8.87564 6.26843 7.87506 6.47758 7.17382 7.17881C6.47328 7.87933 6.26413 8.87856 6.2011 10.5209C6.19895 10.5668 6.16098 10.604 6.11514 10.604H5.92247C5.87591 10.604 5.83794 10.5668 5.83652 10.5209C5.77348 8.87856 5.56433 7.87933 4.86382 7.17881C4.1633 6.4783 3.16195 6.26843 1.51668 6.20611C1.47084 6.20397 1.43359 6.16601 1.43359 6.12016V5.9282C1.43359 5.88164 1.47084 5.84368 1.51668 5.84225C3.16195 5.77993 4.16259 5.57078 4.86382 4.86955C5.56576 4.16761 5.77491 3.16482 5.83723 1.51668C5.83938 1.47084 5.87734 1.43359 5.92318 1.43359H6.11514C6.1617 1.43359 6.19967 1.47084 6.2011 1.51668C6.26341 3.16554 6.47257 4.16761 7.17454 4.86955C7.87506 5.57007 8.87636 5.77993 10.5216 5.84225Z",
					fill: "#FDFDFD"
				})
			})
		})]
	})
});
export default SvgDzen;
